/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseCourseModuleSummaryData } from './genericApiResponseCourseModuleSummaryData';
import type { GenericApiResponseCourseModuleSummaryMessage } from './genericApiResponseCourseModuleSummaryMessage';
import type { GenericApiResponseCourseModuleSummaryPagination } from './genericApiResponseCourseModuleSummaryPagination';
import type { GenericApiResponseCourseModuleSummaryError } from './genericApiResponseCourseModuleSummaryError';

export interface GenericApiResponseCourseModuleSummary {
  data?: GenericApiResponseCourseModuleSummaryData;
  message?: GenericApiResponseCourseModuleSummaryMessage;
  pagination?: GenericApiResponseCourseModuleSummaryPagination;
  error?: GenericApiResponseCourseModuleSummaryError;
  statusCode?: number;
}
